import React, { useEffect } from "react";
import "./App.css";
import { AppMain } from "./layouts/main";
import PusherProvider from "./components/pusher_context";
import AppProvider from "./AppContext";
import axios from "axios";

function App() {
  //call this endpoint on start of the app https://api.ethizo.com/organization_configurations.json
  //response hsould save in local storage
  const fetchOrganizationConfig = async () => {
    try {
      const response = await axios.get(
        ` https://api.ethizo.com/organization_configurations.json`
      );
      localStorage.setItem(
        "organization_config",
        JSON.stringify(response?.data?.response?.data)
      );
    } catch (error) {
      console.error("error", error);
    }
  };

  useEffect(() => {
    fetchOrganizationConfig();
  }, []);

  return (
    <div className="App flex flex-col bg-grey-E4 min-h-screen">
      <AppProvider>
        <PusherProvider>
            <AppMain />
        </PusherProvider>
      </AppProvider>
    </div>
  );
}

export default App;
